import * as colors from '@radix-ui/colors';
import { Button, Flex, Text } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import Icon from '~/components/Icon';
import { ITEMS_PER_PAGE, paginationType } from '~/hooks/use-pagination';
import ComboBox from '../Combobox';

const IconRotated180Degrees = styled(Icon)`
  transform: rotate(180deg);
`;

const getIconColor = (_theme, isDisabled, noTheme) => {
  if (noTheme) return isDisabled ? colors.slate.slate8 : colors.slate.slate12;
  return isDisabled ? 'var(--neutral-8)' : 'var(--neutral-12)';
};

const StyledFlex = styled(Flex)`
  ${props =>
    props.noTheme &&
    css`
      color: ${colors.slate.slate12};
    `};
`;

function Pagination({
  totalPages,
  isPaging,
  currentPage,
  goToNextPage,
  goToPreviousPage,
  justify,
  setItemsPerPage,
  itemsPerPage,
  resetPages,
  noTheme = false,
  showLimitSelector = false,
}) {
  const theme = useTheme();
  const isNoPages = !totalPages;
  const isLeftDisabled = isPaging || isNoPages || currentPage === 1;
  const isRightDisabled = isPaging || isNoPages || currentPage === totalPages;

  return (
    <StyledFlex
      gap='3'
      align='center'
      justify={justify ?? 'end'}
      noTheme={noTheme}
    >
      {showLimitSelector && (
        <Flex flexShrink='0'>
          <ComboBox
            variant='ghost'
            key={itemsPerPage}
            items={ITEMS_PER_PAGE}
            defaultSelected={itemsPerPage}
            onSelectedChange={e => {
              setItemsPerPage(Number(e?.value) || ITEMS_PER_PAGE[0]);
              resetPages();
            }}
            maxVisibleItems={1}
            showSearch={false}
            showClear={false}
            label='per page'
            allowDeselect={false}
            renderLabelInElementFareRight
          />
        </Flex>
      )}
      <Button
        color='gray'
        variant='ghost'
        disabled={isLeftDisabled}
        onClick={goToPreviousPage}
      >
        <IconRotated180Degrees
          name='chevron-right'
          height={20}
          width={20}
          color={getIconColor(theme, isLeftDisabled, noTheme)}
        />
      </Button>
      <Text wrap='nowrap'>
        {totalPages === 0 ? 0 : currentPage} of {totalPages}
      </Text>
      <Button
        color='gray'
        variant='ghost'
        disabled={isRightDisabled}
        onClick={goToNextPage}
      >
        <Icon
          name='chevron-right'
          height={20}
          width={20}
          color={getIconColor(theme, isRightDisabled, noTheme)}
        />
      </Button>
    </StyledFlex>
  );
}

Pagination.propTypes = {
  ...paginationType,
  justify: PropTypes.string,
  noTheme: PropTypes.bool,
  showLimitSelector: PropTypes.bool,
};
export default Pagination;
